import { Button, Flex, Image, Text } from "@chakra-ui/react";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";
import { useTranslation } from "react-i18next";
import { FunnelComponentProps } from "../../funnel/types";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { useQuery, skipToken } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Artist, ServerSingleResponse } from "../../../types";
import { apiClient } from "../../../services/axiosInstance";

export function DonationConfirmationModalBody({
  artistId,
  onClose,
  setFunnelType,
}: FunnelComponentProps) {
  const isMobile = useMobileBreakpoint();
  const { t } = useTranslation();

  const { isLoading, data } = useQuery<
    AxiosResponse<ServerSingleResponse<Artist>>
  >({
    queryKey: ["artist", artistId],
    queryFn: artistId
      ? async () => apiClient.get<ServerSingleResponse<Artist>>(`/v1/artists/${artistId}`)
      : skipToken,
    enabled: !!artistId,
    refetchOnWindowFocus: false,
  });

  const artist = data?.data?.payload.results;
  if (!artist || isLoading) return null;

  const { avatar_small_url, roman_name } = artist;
  return (
    <Flex flexDirection="column" alignItems="center" padding="24px">
      <Image
        borderRadius="24px"
        boxSize={isMobile ? "90px" : "139px"}
        src={avatar_small_url}
        alt="Creator Avatar"
      />
      <Text
        variant="modalTitle"
        fontWeight={600}
        whiteSpace="pre-line"
        textAlign="center"
        mx={8}
        my={8}
      >
        {t("components.payments.donate.wellDoneYouSuccessfullyDonated", {
          artistName: roman_name,
        })}
      </Text>

      <Flex flexDirection="row" gap="16px" width="100%">
        <Button
          variant="primary"
          size="lg"
          flex="1"
          onClick={() => {
            setFunnelType(FUNNEL_TYPES.donate);
          }}
        >
          {t("components.payments.donate.makeAnotherDonation")}
        </Button>
        <Button variant="tertiary" size="lg" flex="1" onClick={onClose}>
          {t("components.payments.donate.imAllSet")}
        </Button>
      </Flex>
    </Flex>
  );
}
